import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "String Projections",
description: "Learn how to display string properties in Freon as single-line or multi-line text fields, and how to use the multiline keyword in projections.",
tags: [ "string projections", "multiline", "text fields", "editor controls", "projectional editor", "string properties", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T18:12:52.262Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};